import Button from '@material-ui/core/Button';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import * as actions from '../actions';
import MainContent from './common/MainContent';

const styles = {
	whenAndPosition: {
		color: 'steelblue',
		fontWeight: '600',
	},
	tag: {
		borderRadius: '2px',
		border: '2px solid steelblue',
		padding: '0.5vw 2vw',
		color: 'steelblue',
		marginRight: '1vw',
		marginTop: '15px',
		display: 'inline-block',
	},
};

class Project extends Component {
	state = {};

	componentDidMount() {
		window.scrollTo(0,0);
	}

	generateTags = (tags) => {
		if (tags) {
			const tagsUI = tags.map((e, i) => {
				return (
					<span key={i} style={styles.tag}>
						{e}
					</span>
				);
			});
			return tagsUI;
		}
	};

	render() {
		const { history, project } = this.props;
		return (
			<MainContent>
				{project && (
					<div className="row">
						<div className="col-12">
							<h2>{project.title}</h2>
						</div>
						<div className="col-md-12">
							When: <span style={styles.whenAndPosition}>{project.year}</span>, Position:{' '}
							<span style={styles.whenAndPosition}>Front-end</span>
						</div>
						{project.tags && <div className="col-md-12 mt-3 mb-5">{this.generateTags(project.tags)}</div>}
						{project.problemContent && (
							<div className="col-md-12 mt-3 mb-3 project">
								<h2 style={{color: "steelblue"}} className="mb-5">Premise and Problem</h2>
								{project.problemContent}
							</div>
						)}
						{project.solutionContent && (
							<div className="col-md-12 mt-3 mb-3 project">
								<h2 style={{color: "steelblue"}} className="mb-5">Solution</h2>
								{project.solutionContent}
							</div>
						)}
					</div>
				)}
				<div className="row d-flex justify-content-center">
					<Button
						color="primary"
						variant="outlined"
						onClick={() => history.push(`/projects`)}
						className="mt-2 mb-2"
					>
						Back to Projects
					</Button>
				</div>
			</MainContent>
		);
	}
}

function mapStateToProps(state, ownProps) {
	const { projectId } = ownProps.match.params;
	const project =
		(state.projects && state.projects.data && state.projects.data.find((e) => e.id && e.id.toString() === projectId)) ||
		{};
	return {
		project,
	};
}

export default withRouter(
	connect(
		mapStateToProps,
		actions,
	)(Project),
);



// WEBPACK FOOTER //
// ./src/components/Project.js